import { PropsWithChildren } from 'react';

export type SortBy = {
  name: string;
  key: string;
};

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export type VoidCallback = () => void;

export type PWC<P, V> = PropsWithChildren<P> & V
export type PWOC<P, V> = P & V

export enum TimeUnit {
  SECOND,
  MINUTE,
  HOUR,
  DAY
}